var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFGlasses2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 18,
    viewBox: "0 0 55 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.2546 8.89052C47.2546 13.2741 43.121 16.8607 38.0688 16.8607C33.0166 16.8607 28.9749 13.2741 28.9749 8.89052C28.9749 4.5069 33.0166 1 38.0688 1C43.121 1 47.2546 4.5069 47.2546 8.89052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.7495 8.89052C24.7495 13.2741 20.7077 16.8607 15.6555 16.8607C10.6033 16.8607 6.46973 13.2741 6.46973 8.89052C6.46973 4.5069 10.6033 1 15.6555 1C20.7077 1 24.7495 4.5069 24.7495 8.89052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7495 8.89052C24.7495 13.2741 20.7077 16.8607 15.6555 16.8607C10.6033 16.8607 6.46973 13.2741 6.46973 8.89052C6.46973 4.5069 10.6033 1 15.6555 1C20.7077 1 24.7495 4.5069 24.7495 8.89052Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2546 8.89052C47.2546 13.2741 43.121 16.8607 38.0688 16.8607C33.0166 16.8607 28.9749 13.2741 28.9749 8.89052C28.9749 4.5069 33.0166 1 38.0688 1C43.121 1 47.2546 4.5069 47.2546 8.89052Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7495 8.89046C24.7495 8.89046 26.9541 7.13701 28.975 8.89046",
    stroke: "#1A1A1A",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46973 8.89043L1 9.46619",
    stroke: "#1A1A1A",
    strokeWidth: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 9L47.53 8.89044",
    stroke: "#1A1A1A",
    strokeWidth: 0.35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFGlasses2);
export default __webpack_public_path__ + "static/media/f-glasses-2.e3b97669f645c78f00619aaa09e087f4.svg";
export { ForwardRef as ReactComponent };